var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('read', 'ipg-gateway'))?_c('main-content',[_c('manage-dedicated')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }